import React from 'react';
import { CHECKOUT_URL } from '../CTAButton';
export function Footer() {
  return <footer className="w-full border-t border-ink-600 bg-ink-800 px-4 pb-32 pt-12 sm:px-6" data-id="element-156" data-mp="207t3odpd7tno">
      <div className="mx-auto w-full max-w-3xl text-center" data-id="element-157" data-mp="2f4tjbiua7y5s">
        <p className="font-display text-2xl font-extrabold uppercase tracking-wide text-white" data-id="element-158" data-mp="2f421rbxis0yi">
          Weld Decision System™
        </p>
        <p className="mt-1 text-[13px] text-zinc-400" data-id="element-159" data-mp="1mfwgmo2k09y5">Created by Juan Escamilla</p>

        <nav className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-160" data-mp="1mdtdr3gaymc0">
          {['Terms & Conditions', 'Privacy Policy', 'Contact'].map(l => <a key={l} href={CHECKOUT_URL} className="text-[13px] font-medium text-zinc-400 underline-offset-4 transition-colors duration-150 ease-out hover:text-white hover:underline" data-id="element-161" data-mp="1w7ims601biu1">
              {l}
            </a>)}
        </nav>

        <p className="mt-6 text-[12px] leading-relaxed text-zinc-500" data-id="element-162" data-mp="yq21fzuri9aq">
          © 2026 Weld Decision System™ — All Rights Reserved.
        </p>
      </div>
    </footer>;
}